import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ColectieHero } from '../components/colectie/ColectieHero';
import { ColectieProblem } from '../components/colectie/ColectieProblem';
import { ColectieCurriculum } from '../components/colectie/ColectieCurriculum';
import { ColectieBenefits } from '../components/colectie/ColectieBenefits';
import { ColectieAbout } from '../components/colectie/ColectieAbout';
import { ColectieForWho } from '../components/colectie/ColectieForWho';
import { ColectiePricing } from '../components/colectie/ColectiePricing';
import { ColectieTestimonials } from '../components/colectie/ColectieTestimonials';
import { ColectieFAQ } from '../components/colectie/ColectieFAQ';
export function ColectiePage() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2294">
      <Header data-id="element-2295" />
      <main data-id="element-2296">
        <ColectieHero data-id="element-2297" />
        <ColectieProblem data-id="element-2298" />
        <ColectieCurriculum data-id="element-2299" />
        <ColectieBenefits data-id="element-2300" />
        <ColectieAbout data-id="element-2301" />
        <ColectieForWho data-id="element-2302" />
        <ColectiePricing data-id="element-2303" />
        <ColectieTestimonials data-id="element-2304" />
        <ColectieFAQ data-id="element-2305" />
      </main>
      <Footer data-id="element-2306" />
    </div>;
}